import a from "./design-system.es280.js";
import { getScrollParent as c, isDocument as l, distanceToTopEdge as r, distanceToBottomEdge as n } from "./design-system.es140.js";
import { openBlock as h, createElementBlock as u, withDirectives as p, createElementVNode as m, renderSlot as g, vShow as f } from "vue";
/* empty css                    */
import E from "./design-system.es128.js";
const w = {
  name: "DsInfiniteScroll",
  props: {
    /**
     * Boolean to be set by parent after each load to let InfiniteScroll know if there is more data to fetch
     */
    noMoreData: {
      type: Boolean,
      required: !0
    },
    /**
     * Boolean to be set by parent after each load to let InfiniteScroll know when the parent is loading
     */
    loading: {
      type: Boolean,
      required: !0
    },
    /**
     * Initial limit for request, InfiniteScroll will optimize limit for screen height
     */
    limit: {
      type: Number,
      required: !0,
      sync: !0
      // must be synced
    },
    /**
     * Controls the scrolling direction of infinite scroll
     */
    scrollDirection: {
      type: String,
      default: "down",
      validator: (e) => ["down", "up"].includes(e)
    },
    /**
     * Distance from the last list item to the bottom of window or scroll container (whichever is less) to trigger load
     */
    threshold: {
      type: Number,
      default: 200,
      dimension: "pixels"
    },
    /**
     * Debounce delay for load function
     */
    debounceDelay: {
      type: Number,
      default: 300,
      dimension: "seconds"
    },
    /**
     * Disable InfiniteScroll at any time, maintains enabled state
     */
    disabled: Boolean
  },
  emits: [
    "load",
    "update:limit"
  ],
  data() {
    return {
      scroller: null,
      placeholder: null,
      placeholderHeight: 0,
      localLoading: this.loading,
      isFirstLoad: !0
    };
  },
  computed: {
    showPlaceholder() {
      return !this.disabled && this.localLoading || !this.disabled && !this.noMoreData;
    }
  },
  watch: {
    disabled(e) {
      this.$nextTick(() => {
        e ? window.removeEventListener("scroll", this.handleScroll, !0) : (window.addEventListener("scroll", this.handleScroll, !0), this.initializeInfiniteScroll());
      });
    },
    loading(e) {
      this.localLoading = e;
    }
  },
  created() {
    this.debounceDelay > 0 && (this.load = a(this.load, this.debounceDelay));
  },
  mounted() {
    this.disabled || this.initializeInfiniteScroll(), window.addEventListener("scroll", this.handleScroll, !0);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll, !0);
  },
  methods: {
    initializeInfiniteScroll() {
      var e;
      if (this.$slots.default) {
        const { placeholder: t } = this.$refs;
        this.placeholder = t.children.length === 1 ? t.querySelector(".placeholder") : t.children[0];
      }
      if ((e = this.placeholder) != null && e.nodeName) {
        const { marginTop: t, marginBottom: i } = window.getComputedStyle(this.placeholder, null);
        this.placeholderHeight = this.placeholder.offsetHeight + parseInt(t, 10) + parseInt(i, 10);
      } else
        this.placeholderHeight = 0;
      this.scroller = c(this.placeholder || this.$parent.$el), this.calculateOptimalLimit(), this.isFirstLoad && (this.isFirstLoad = !1, this.load());
    },
    handleScroll({ target: e }) {
      const t = l(e), i = this.isTarget(e);
      !this.localLoading && !this.noMoreData && (i || t) && this.isWithinThreshold() && (this.localLoading = !0, this.load());
    },
    load() {
      this.$emit("load");
    },
    calculateOptimalLimit() {
      let e = 0;
      const t = 100, { distanceToScrollerEdge: i, distanceToWindowEdge: o } = this.getEdgeDistances(), s = l(this.scroller) ? o : Math.min(o, i);
      e = Math.ceil((s + t) / this.placeholderHeight), Number.isFinite(e) || (e = 1), e && e > this.limit && this.$emit("update:limit", e);
    },
    getEdgeDistances() {
      return this.scrollDirection === "up" ? {
        distanceToScrollerEdge: r(this.placeholder, this.scroller),
        distanceToWindowEdge: r(this.placeholder, document)
      } : {
        distanceToScrollerEdge: n(this.placeholder, this.scroller, !0),
        distanceToWindowEdge: n(this.placeholder, document, !0)
      };
    },
    isTarget(e) {
      return e === this.scroller || l(e) && l(this.scroller);
    },
    isWithinThreshold() {
      const { distanceToScrollerEdge: e, distanceToWindowEdge: t } = this.getEdgeDistances();
      return l(this.scroller) ? t >= -this.threshold : Math.min(t, e) >= -this.threshold;
    }
  }
}, T = { class: "infinite-scroll" }, S = {
  ref: "placeholder",
  class: "infinite-scroll-placeholder"
};
function D(e, t, i, o, s, d) {
  return h(), u("div", T, [
    p(m("div", S, [
      g(e.$slots, "default", {}, void 0, !0)
    ], 512), [
      [f, d.showPlaceholder]
    ])
  ]);
}
const $ = /* @__PURE__ */ E(w, [["render", D], ["__scopeId", "data-v-6e62de2e"]]);
export {
  $ as default
};
//# sourceMappingURL=design-system.es61.js.map
